<template>
  <div v-if="item" class="mt-2">
    <copy-participant-ssn :item="item"></copy-participant-ssn>
    <div class="col-12">
      <span>{{item.message}}</span>
    </div>
  </div>
</template>

<script>
import CopyParticipantSsn from './CopyParticipantSsn.vue';

export default {
  props: ["item"],
  methods: {
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/action-items/types/AccountLinkActionItem.vue